"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalContext = useModalContext;
exports["default"] = exports.ModalContextProviderWrapper = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _store = _interopRequireWildcard(require("./store"));

var _context = _interopRequireDefault(require("./context"));

function useModalContext() {
  var context = _react["default"].useContext(_context["default"]);

  if (!context) {
    throw new Error('ModalContext cannot be rendered outside the ModalContext provider');
  }

  return context;
} // HOC for Modal Context


var withModalContext = function withModalContext(WrappedComponent) {
  return function (props) {
    var _useReducer = (0, _react.useReducer)(_store["default"], _store.initialState),
        _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
        state = _useReducer2[0],
        dispatch = _useReducer2[1];

    return _react["default"].createElement(_context["default"].Provider, {
      value: {
        state: state,
        dispatch: dispatch
      }
    }, _react["default"].createElement(WrappedComponent, props));
  };
}; // Wrapper for using Modal Context Provider


var ModalContextProviderWrapper = function ModalContextProviderWrapper(_ref) {
  var children = _ref.children;

  var _useReducer3 = (0, _react.useReducer)(_store["default"], _store.initialState),
      _useReducer4 = (0, _slicedToArray2["default"])(_useReducer3, 2),
      state = _useReducer4[0],
      dispatch = _useReducer4[1];

  return _react["default"].createElement(_context["default"].Provider, {
    value: {
      state: state,
      dispatch: dispatch
    }
  }, children);
};

exports.ModalContextProviderWrapper = ModalContextProviderWrapper;
ModalContextProviderWrapper.propTypes = {
  children: _propTypes["default"].node
};
var _default = withModalContext;
exports["default"] = _default;